import { render, staticRenderFns } from "./TableRiskAppraisal592.vue?vue&type=template&id=24b04dd8&scoped=true"
import script from "./TableRiskAppraisal592.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal592.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal592.vue?vue&type=style&index=0&id=24b04dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b04dd8",
  null
  
)

export default component.exports